import { render, staticRenderFns } from "./common-article-edit.vue?vue&type=template&id=f1a6cc34&scoped=true&"
import script from "./common-article-edit.vue?vue&type=script&lang=js&"
export * from "./common-article-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a6cc34",
  null
  
)

export default component.exports